module.exports = __webpack_public_path__ + "img/freestyle_box13.71518320.jpg";